import { Box, Typography } from '@mui/material';

interface ErrorContentProps {
  errorMessage?: string;
}

export const ErrorContent = ({ errorMessage = 'Errore caricamento dati' }: ErrorContentProps) => {
  return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight="70vh">
      <Typography color="error">{errorMessage}</Typography>
    </Box>
  );
};
